import { defineMessages } from "react-intl";
export var messages = defineMessages({
  themeSettingsLabel: {
    id: "jutro-components.ThemeSettingsCard.label",
    defaultMessage: "Current theme"
  }
});